import React from 'react';
import 'components/page-500/page-500.scss';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslator } from 'tools/view-hooks/translator-hook';

const Page500: React.FC = () => {
    const { translate } = useTranslator();
    const navigate = useNavigate();

    // Dentro del tab de Recepción no hay back nativo: sin esta salida el
    // usuario queda encerrado hasta cambiar de tab.
    const canGoBack = window.history.length > 1;

    return (
        <div className={'page-500'}>
            <Result
                status="500"
                title="500"
                subTitle={translate({ key: 'common-errors.server-error-sub' })}
                extra={
                    canGoBack ? (
                        <Button type="primary" onClick={() => navigate(-1)}>
                            {translate({ key: 'common-errors.back-label' })}
                        </Button>
                    ) : undefined
                }
            />
        </div>
    );
};

export default Page500;
